<template>
  <Transition
    name="slide-in-top"
    @mouseover="openMegaNav(megaNavMenu)"
    @mouseleave="delayedCloseMegaNav"
  >
    <div v-if="isOpen" class="mega-nav">
      <div class="grid">
        <div
          v-for="(column, columnIndex) in columns"
          :key="columnIndex"
          class="col"
          :class="{ 'col--stretch': column.stretch }"
        >
          <div
            v-for="(group, groupIndex) in column.groups"
            :key="groupIndex"
            class="group"
          >
            <div v-if="group.title" class="group__heading">
              {{ group.title }}
            </div>
            <ul class="nav__list">
              <li
                v-for="(link, linkIndex) in group.links"
                :key="linkIndex"
                class="nav__item"
              >
                <Button
                  form="underline-invert"
                  :class="getLinkClass(link)"
                  tag="a"
                  :href="link.url || null"
                >
                  {{ link.title }}
                </Button>
                <div class="badges">
                  <Badge
                    v-for="(badge, index) in link.badges"
                    :key="index"
                    size="small"
                    :theme="badge.theme"
                  >
                    {{ badge.text }}
                  </Badge>
                </div>
              </li>
            </ul>
          </div>
          <NavigationBanner
            v-if="column.banner"
            :stretch="column.stretch"
            :images="column.banner.images"
            :text="column.banner.text"
            :url="column.banner.url"
            :theme="column.banner.theme"
          />
        </div>
      </div>
    </div>
  </Transition>
  <Transition name="fade">
    <div v-if="isOpen" class="blur"></div>
  </Transition>
</template>

<script>
import Button from "@/components/ButtonV2.vue";
import NavigationBanner from "@/components/navigation/NavigationBanner.vue";
import { mapState, mapActions } from "vuex";
// import navigationContent from "@/content/navigation.json";
import Badge from "@/components/BadgeV2.vue";

export default {
  name: "DesktopMegaNav",
  components: {
    Button,
    NavigationBanner,
    Badge,
  },
  computed: {
    ...mapState("app", ["isMegaNavOpen", "megaNavMenu", "navVersion"]),
    columns() {
      const matchedNav = this.navigation.items.find((item) => {
        return item.slug === this.megaNavMenu;
      });

      return matchedNav?.mega?.columns;
    },
    isOpen() {
      return this.isMegaNavOpen && this.columns;
    },
    navigation() {
      try {
        return require(`@/content/navigationV${this.navVersion}.json`);
      } catch (e) {
        console.error(e);
        return require(`@/content/navigationV2.json`);
      }
    },
  },
  methods: {
    ...mapActions("app", ["openMegaNav", "delayedCloseMegaNav"]),
    getLinkClass(navItem) {
      const baseClass = "nav__link";
      const modifierClass = navItem.modifier
        ? `nav__link--${navItem.modifier}`
        : "";
      return `${baseClass} ${modifierClass}`.trim();
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  color: red;
}

.mega-nav {
  background-color: $color-white;
  position: relative;
  z-index: 4;
}

.blur {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur($blur-amount);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-in-top-enter-active,
.slide-in-top-leave-active {
  transition: transform 0.25s ease-out, opacity 0.25s ease-out;
  opacity: 1;
}

.slide-in-top-enter-from,
.slide-in-top-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}

.grid {
  display: grid;
  padding: 15px 40px 60px;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;

  .col--stretch {
    grid-column: span 2;
  }
}

.nav__list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.group {
  margin-bottom: 40px;
}

.group__heading {
  @include utility-label(12px);
  color: $color-grey-dark;
  text-transform: uppercase;
  margin-bottom: 23px;
}

.badges {
  position: relative;
  top: -5px;
  display: inline-block;
}

.nav__link {
  @include editorial-body(16px);
  text-transform: none;
  display: inline-block;
  &--highlight {
    color: $color-red;
  }
  &--italic {
    font-style: italic !important;
  }
  &--disabled {
    pointer-events: none;
    opacity: 0.5;
    cursor: not-allowed;
  }
}
</style>

<style lang="scss">
.header-wrapper {
  .header,
  .banner {
    position: relative;
    z-index: 5;
  }
}
</style>
